import { Component, computed, input, output } from '@angular/core';
import { faArrowRight, faMessageCheck } from '@fortawesome/pro-regular-svg-icons';
import { SurveyModel } from '@empathy/survey/base';

@Component({
  selector: 'empathy-welcome-page-view',
  templateUrl: 'welcome-page-view.component.html',
  styleUrls: ['./welcome-page-view.component.scss', './_welcome-page-view-theme.component.scss']
})
export class WelcomePageViewComponent {
  surveyModel = input.required<SurveyModel>();
  start = output();

  faArrowRight = faArrowRight;
  faMessageCheck = faMessageCheck;

  questions$ = computed(() => this.surveyModel().questions.length);
}
